import {MainTitle as Component, Description} from './MainTitle'

export const MainTitle = Object.assign(Component, {...Component, Description})
